module.exports = __webpack_public_path__ + "static/img/aq.436f0a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/introduce/images/aq.png
// module id = 7OgJ
// module chunks = 21